const getLicense = async (id) =>
{
    try
    {
        const response = await fetch(`https://0nsyxtmmk4.execute-api.eu-central-1.amazonaws.com/licenses/${id}`);
        if (!response.ok)
        {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        const data = await response.json(); // assuming the response is JSON
        return data;
    }
    catch (error)
    {
        console.error('Fetch error:', error);
        return {
            isOk: false,
            message: "Can not fetch user license data. Try again later or contact administator."
        };
    }
}

export default getLicense;